import { Link, Outlet } from "react-router-dom";
import { toast } from "sonner";
import { useAdminAuth } from "@/context/AdminAuthContext";

export default function AdminLayout() {
  const { admin, logout } = useAdminAuth();

  async function handleLogout() {
    try {
      await logout();
      toast.success("Signed out.");
    } catch {
      toast.error("Something went wrong signing out.");
    }
  }

  return (
    <div className="min-h-screen bg-[#F5F4F1]">
      <header
        data-testid="admin-header"
        className="border-b border-[#E7E5E4] bg-[#FAFAF8]"
      >
        <div className="max-w-6xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
          <Link to="/admin" className="font-display text-xl tracking-tight text-[#1C1917]">
            Blueprint<span className="text-[#FF5A4F]">4</span>Joy
            <span className="text-[#57534E] text-sm font-sans ml-2">Admin</span>
          </Link>
          <div className="flex items-center gap-5">
            {admin?.email && (
              <span data-testid="admin-header-email" className="text-sm text-[#57534E] hidden sm:inline">
                {admin.email}
              </span>
            )}
            <button
              onClick={handleLogout}
              data-testid="admin-logout-button"
              className="text-sm font-medium text-[#159E9A] hover:text-[#0f7a77] transition-colors"
            >
              Log out
            </button>
          </div>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-6 md:px-10 py-10 md:py-14">
        <Outlet />
      </main>
    </div>
  );
}
